import { render, staticRenderFns } from "./LandingLink.vue?vue&type=template&id=a50e212a&scoped=true&lang=pug"
import script from "./LandingLink.vue?vue&type=script&lang=js"
export * from "./LandingLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50e212a",
  null
  
)

export default component.exports